import { RESET_DATA, SET_DATA } from 'modules/Stories/types'

const initialState = {
  data: [],
  loading: false,
  loaded: false,
  failed: false,
}

const setData = (state, action) => ({
  ...state,
  ...action.payload,
})

const resetData = () => ({
  ...initialState,
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA:
      return setData(state, action)
    case RESET_DATA:
      return resetData()

    default:
      return state
  }
}

export default reducer
